import React, { useEffect, useRef, useState } from "react";

import axiosInstance from "../../../../Fbaseurl";
import { setSelectedTab } from "../../../../store/reducers/SuperAdminReducer";
import { showToast } from "../../../../store/reducers/ToastMessageReducer";
import { setSalesPersonSelectedTab } from "../../../../store/reducers/SalespersonReducer";
import Support from "../Support";
import "./index.css";
import Logo from "../../../../assets/Taxraven.svg";
import SuperAdminIcon from "../../../../assets/SuperAdminIcon.svg";
import salesPersonIcon from "../../../../assets/SalespersonIcon.svg";
import CompanyAdminIcon from "../../../../assets/CompanyAdminIcon.svg";
import SalespersonManagerIcon from "../../../../assets/SalespersonManagerIcon.svg";
import LogoutIcon from "../../../../assets/LogoutIcon.svg";
import closeOutline from "../../../../assets/closeOutline.svg";
import mail from "../../../../assets/mail.svg";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  setCurrentRole,
  // setAuthorisedUser,
  // setIsAuthorised,
} from "../../../../store/reducers/AppReducer";
import {
  getRoleBasePath,
  isSuperAdminRole,
  normalizeRoleForRouting,
} from "../../../../CommonUtils/roles";
import CircularProgress from "@mui/material/CircularProgress";
import { useMediaQuery } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Drawer, IconButton, Box, Typography } from "@mui/material";
import RButton from "@mui/material/Button";
import { useMsalLogout } from "../../../../Hooks/useMsalLogout";

const Header = (props) => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentRole = useSelector((state) => state.App.currentRole);
  const authorisedUser = useSelector((state) => state.App.authorisedUser);
  const name = useSelector((state) => state.App.userName);
  const [anchorEl, setAnchorEl] = useState(null);
  const [dataFetchStatus, setDataFetchStatus] = useState("");
  const open = Boolean(anchorEl);
  const [tabsMenuopen, setTabsMenuOpen] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [companyOptions, setCompanyOptions] = useState([]);
  const [selectedCompanyOption, setSelectedCompanyOption] = useState(null);
  const [companyMenuOpen, setCompanyMenuOpen] = useState(false);
  const companyMenuRef = useRef(null);
  const { logout: logoutWithMsal } = useMsalLogout();
  const isSuperAdminUser = Array.isArray(authorisedUser?.roles)
    ? authorisedUser.roles.includes("SuperAdmin")
    : false;
  const shouldUseGlobalCompanyList =
    isSuperAdminUser &&
    ["Salesperson", "CompanyAdmin", "Manager", "SuperAdmin"].includes(
      currentRole
    );
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    handleClose();
    await logoutWithMsal();
  };

  const normalizeCompanyOptions = (profile) => {
    if (!profile) return [];
    const options = [];
    const pushCompany = (company) => {
      if (!company) return;
      const derivedId =
        company?.companyId ||
        company?.id ||
        company?.userCompanyId ||
        company?.companyID;
      if (!derivedId) return;
      options.push({
        id: derivedId,
        key:
          company?.companyName ||
          company?.name ||
          company?.company ||
          `Company ${derivedId}`,
      });
    };
    if (Array.isArray(profile?.companiesAssignedData)) {
      profile.companiesAssignedData.forEach(pushCompany);
    } else if (Array.isArray(profile?.companies)) {
      profile.companies.forEach(pushCompany);
    }
    if (!options.length && profile?.companyId) {
      options.push({
        id: profile.companyId,
        key: profile.companyName || `Company ${profile.companyId}`,
      });
    }
    return options;
  };

  const getPreferredCompanyOption = (options, fallbackCompanyId) => {
    if (!options.length) {
      return null;
    }
    const storedCompanyId = localStorage.getItem("selectedLrpCompanyId");
    if (storedCompanyId) {
      const storedMatch = options.find(
        (option) => option.id?.toString() === storedCompanyId
      );
      if (storedMatch) {
        return storedMatch;
      }
    }
    if (fallbackCompanyId) {
      const fallbackMatch = options.find(
        (option) => option.id === fallbackCompanyId
      );
      if (fallbackMatch) {
        return fallbackMatch;
      }
    }
    return options[0];
  };

  useEffect(() => {
    getCurrentRole();
  }, []);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        companyMenuRef.current &&
        !companyMenuRef.current.contains(event.target)
      ) {
        setCompanyMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, []);

  useEffect(() => {
    if (shouldUseGlobalCompanyList) {
      return;
    }
    let isMounted = true;
    const fetchCompanies = async () => {
      if (!authorisedUser?.userName) return;
      try {
        const response = await axiosInstance.get(
          `/users/${encodeURIComponent(authorisedUser.userName)}`
        );
        if (!isMounted) {
          return;
        }
        const options = normalizeCompanyOptions(response?.data);
        setCompanyOptions(options);
        if (options.length) {
          const preferred = getPreferredCompanyOption(
            options,
            response?.data?.companyId
          );
          setSelectedCompanyOption(preferred);
          if (preferred?.id) {
            localStorage.setItem(
              "selectedLrpCompanyId",
              preferred.id?.toString() || ""
            );
          }
        } else {
          setSelectedCompanyOption(null);
        }
      } catch (error) {
        console.log("Failed to fetch companies", error);
      }
    };
    fetchCompanies();
    return () => {
      isMounted = false;
    };
  }, [authorisedUser?.userName, shouldUseGlobalCompanyList]);

  useEffect(() => {
    if (!shouldUseGlobalCompanyList) {
      return;
    }
    let isMounted = true;
    const fetchAllCompanies = async () => {
      try {
        let page = 1;
        const pageSize = 50;
        let totalPages = 1;
        const aggregatedOptions = [];
        do {
          const response = await axiosInstance.get(`/companies`, {
            params: { page, pageSize },
          });
          const responseData = response?.data;
          if (Array.isArray(responseData?.items)) {
            responseData.items.forEach((company) => {
              if (!company?.companyId) {
                return;
              }
              aggregatedOptions.push({
                id: company.companyId,
                key: company.companyName || `Company ${company.companyId}`,
              });
            });
          }
          totalPages = responseData?.totalPages || 1;
          page += 1;
        } while (page <= totalPages);

        if (!isMounted) {
          return;
        }
        setCompanyOptions(aggregatedOptions);
        if (aggregatedOptions.length) {
          const preferred = getPreferredCompanyOption(aggregatedOptions);
          setSelectedCompanyOption(preferred);
          if (preferred?.id) {
            localStorage.setItem(
              "selectedLrpCompanyId",
              preferred.id?.toString() || ""
            );
          }
        } else {
          setSelectedCompanyOption(null);
        }
      } catch (error) {
        console.log(
          "Failed to fetch all companies for super admin salesperson view",
          error
        );
      }
    };
    fetchAllCompanies();
    return () => {
      isMounted = false;
    };
  }, [shouldUseGlobalCompanyList]);
  const findUserIcon = () => {
    switch (currentRole) {
      case 0:
      case "0":
      case "Salesperson":
        return salesPersonIcon;
      case "SuperAdmin":
        return SuperAdminIcon;
      case "Manager":
        return SuperAdminIcon;
      case "CompanyAdmin":
        return CompanyAdminIcon;
      default:
        return SuperAdminIcon;
    }
  };
  const roles = () => {
    if (!Array.isArray(authorisedUser?.roles)) {
      return [];
    }
    const rolesList = [];
    authorisedUser.roles.forEach((item) => {
      if (item === 0 || item === "0" || item === "Salesperson") {
        rolesList.push({
          name: "Salesperson",
          to: "/salesperson/findBusinavTab",
          key: "Salesperson",
          icon: salesPersonIcon,
        });
      } else if (item === "Manager") {
        rolesList.push({
          name: "Manager",
          to: "/manager/dashboard/users",
          key: "Manager",
          icon: SuperAdminIcon,
        });
      } else if (item === "CompanyAdmin") {
        rolesList.push({
          name: "Company Admin",
          to: "/companyadmin/dashboard/users",
          key: "CompanyAdmin",
          icon: CompanyAdminIcon,
        });
      }
    });
    return rolesList;
  };

  const handleCompanySelection = (option) => {
    setSelectedCompanyOption(option);
    setCompanyMenuOpen(false);
    try {
      localStorage.setItem("selectedLrpCompanyId", option?.id || "");
    } catch (error) {
      console.log("Unable to persist selected company", error);
    }
  };

  const handleNavigation = async (role) => {
    setDataFetchStatus("TRIGGERED");
    try {
      const response = await axiosInstance.put(
        `/users/currentRole/${role.key}`
      );
      if (response) {
        localStorage.setItem("currentRole", role.key);
        if (role.key === "Salesperson") {
          dispatch(setSalesPersonSelectedTab(0));
        } else {
          dispatch(setSelectedTab(0));
        }
        dispatch(setCurrentRole(role.key));
        navigate(role.to);
        setDataFetchStatus("FETCHED_SUCCESSFULLY");
      }
    } catch (error) {
      let errorMsg = error?.response?.data?.title;
      dispatch(
        showToast({
          type: "error",
          message: errorMsg || `Failed to switch the account. Please try again`,
        })
      );
      setDataFetchStatus("FAILED_TO_FETCH");
      console.log(error);
    }
    // window.location.reload()
  };

  const getCurrentRole = async () => {
    try {
      const response = await axiosInstance.get(`/users/currentRole`);
      const apiRole = (response?.data || "").toString().trim();
      if (!apiRole || apiRole === "None") {
        return;
      }
      const normalizedRole = normalizeRoleForRouting(apiRole);

      localStorage.setItem("currentRole", normalizedRole);
      dispatch(setCurrentRole(normalizedRole));

    } catch (error) {
      console.log(error);
    }
  };

  const toggleDrawer = (event, open) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setTabsMenuOpen(open);
  };

  const handleTabChange = (event, newValue) => {
    if (newValue?.disabled) {
      return;
    }
    dispatch(props.setSelectedTab(newValue.key));
    setTabsMenuOpen(false);
  };

  const getDashboardLoginHint = () => {
    const storedHint = localStorage.getItem("lastLoginHint");
    if (storedHint) return storedHint;

    try {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      if (user?.userName) return user.userName;
      if (user?.email) return user.email;
    } catch (e) {
      console.log("Failed to parse stored user for loginHint", e);
    }

    return null;
  };

  const navigateToDashboardApp = () => {
    const baseDomain =
      process.env.REACT_APP_DASHBOARD_URL ||
      "https://dashboard.canaryai.com/";
    const targetDomain = baseDomain.endsWith("/dashboard")
      ? baseDomain
      : `${baseDomain.replace(/\/$/, "")}/dashboard`;

    const loginHint = getDashboardLoginHint();

    if (!loginHint) {
      window.location.href = targetDomain;
      return;
    }

    const separator = targetDomain.includes("?") ? "&" : "?";
    const ssoUrl = `${targetDomain}${separator}login_hint=${encodeURIComponent(
      loginHint
    )}`;

    window.location.href = ssoUrl;
  };

  const navigateToDashboard = () => {
    dispatch(setSelectedTab(0));
    dispatch(setSalesPersonSelectedTab(0));
    switch (currentRole) {
      case "SuperAdmin":
        return navigate(`${getRoleBasePath(currentRole)}/findBusinavTab`);
      case 0:
      case "0":
      case "Salesperson":
        return navigate("/salesperson/findBusinavTab");
      case "Manager":
        return navigate("/manager/dashboard/users");
      case "CompanyAdmin":
        return navigate("/companyadmin/dashboard/users");
      default:
        return "";
    }
  };

  const cuurentLoggedinRole = () => {
    switch (currentRole) {
      // case "SuperAdmin":
      //   return "Super Admin";
      case "Salesperson":
        return "Salesperson";
      case "Manager":
        return "Manager";
      case "CompanyAdmin":
        return "Company Admin";
      default:
        return "";
    }
  };
  const availableRoles = roles();

  return (
    <div
      className={`hidden-on-print header-wrapper d-lg-flex d-md-flex d-flex justify-content-between align-items-center ${
        isMobile ? " px-3" : " px-4"
      }`}
    >
      {isMobile && props.tabs?.length > 0 && (
        <div>
          <MenuIcon onClick={(e) => toggleDrawer(e, true)}></MenuIcon>
        </div>
      )}
      <div className="text-center mb-lg-0 mb-md-0">
        <div className="d-flex align-items-center gap-3 logo-company-select">
          <img
            src={Logo}
            alt="logo"
            width={95}
            height={!isMobile ? 40 : null}
            className="cursor-pointer color-yellow"
            onClick={navigateToDashboard}
          />
          {companyOptions.length > 0 && (
            <div className="lrp-company-pill-wrapper" ref={companyMenuRef}>
              <button
                type="button"
                className={`lrp-company-pill ${
                  companyMenuOpen ? "is-open" : ""
                }`}
                onClick={() => setCompanyMenuOpen((value) => !value)}
              >
                <span className="lrp-company-pill__text">
                  {selectedCompanyOption?.key || "Select company"}
                </span>
                <ExpandMoreIcon
                  className={`lrp-company-pill__icon ${
                    companyMenuOpen ? "rotated" : ""
                  }`}
                />
              </button>
              {companyMenuOpen && (
                <div className="lrp-company-menu">
                  {companyOptions.map((option) => (
                    <button
                      type="button"
                      key={option.id}
                      className={`lrp-company-menu__item ${
                        option.id === selectedCompanyOption?.id ? "active" : ""
                      }`}
                      onClick={() => handleCompanySelection(option)}
                    >
                      {option.key}
                    </button>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      <div
        className={` d-flex  align-items-center  py-2 gap-2 ${
          isMobile ? "" : " p-2 "
        }`}
      >
        <div className="dashboard-btn-wrapper">
          <RButton
            variant="outlined"
            size={isMobile ? "small" : "medium"}
            className=" my-auto"
            sx={{
              textTransform: "none",
              borderRadius: "999px",
              backgroundColor: "#FFFFFF",
              borderColor: "#D79C1F",
              color: "#4B1F73",
              px: isMobile ? 2 : 3,
              fontWeight: 700,
              "&:hover": {
                backgroundColor: "#FFF7DB",
                borderColor: "#D79C1F",
              },
            }}
            onClick={navigateToDashboardApp}
          >
            Go to Dashboard
          </RButton>
        </div>
        <div className={`${!isMobile ? "px-2 admin-controls" : ""}`}>
          <RButton
            variant="outlined"
            size={isMobile ? "small" : "medium"}
            className=" my-auto"
            // color="primary"
            sx={{
              textTransform: "none",
              borderRadius: "8px",
              backgroundColor: "#FFCC33",
              borderColor: "#FFCC33",
              "&:hover": {
                backgroundColor: "#e6b800",
                borderColor: "#e6b800",
              },
            }}
            onClick={() => setIsPopupOpen(true)}
          >
            <img src={mail} alt="mail" className="px-1"></img> Support
          </RButton>
        </div>

        <img
          src={findUserIcon()}
          alt="UserIcon"
          width={`${isMobile ? "24px" : "40px"}`}
          height={`${isMobile ? "24px" : "40px"}`}
          onClick={(e) => (isMobile ? handleClick(e) : "")}
        />
        {!isMobile && (
          <div>
            <p className="admin-name m-0 fw-bold" style={{ fontFamily: '"IBM Plex Serif", serif' }}>
              {name}
            </p>
            <div className="role" style={{ fontFamily: '"IBM Plex Serif", serif' }}>
              {cuurentLoggedinRole()}
            </div>
          </div>
        )}
        <div>
          {!isMobile && (
            <ExpandMoreIcon
              onClick={handleClick}
              className="control-icon align-self-center"
            />
          )}
          <Menu
            anchorEl={anchorEl}
            id="header-account-menu"
            className="header-account-menu"
            open={open}
            onClose={handleClose}
            onClick={handleClose}
            slotProps={{
              paper: {
                elevation: 0,
                sx: {
                  overflow: "visible",
                  filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                  mt: 2.2,
                  border: "1px solid #EBEBEC",
                  // borderRadius: "16px",
                  "& .MuiAvatar-root": {
                    width: 32,
                    height: 45,
                    ml: -0.5,
                    mr: 1,
                  },
                },
              },
            }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            {availableRoles && availableRoles.length > 1 && (
              <React.Fragment>
                <div className="p-3 font-14 font-700 text-lightgrey " style={{ fontFamily: '"IBM Plex Serif", serif' }}>
                  Change role
                </div>
                {availableRoles.map((role) => (
                  <MenuItem
                    key={role.key}
                    onClick={() => handleNavigation(role)}
                    className={`px-3 py-2 ${
                      currentRole === role.key ? "selected-role" : ""
                    }`}
                  >
                    <img
                      src={role.icon}
                      alt={role.name}
                      width="24px"
                      height="24px"
                      className="m-right"
                    />{" "}
                    {role.name}
                  </MenuItem>
                ))}
                <hr className="m-0 p-0"></hr>
              </React.Fragment>
            )}
            <MenuItem onClick={handleLogout}>
              <img
                src={LogoutIcon}
                alt="Logout"
                width="24px"
                height="24px"
                className="m-right"
              />
              Logout
            </MenuItem>
          </Menu>
        </div>
      </div>
      {dataFetchStatus === "TRIGGERED" && (
        <CircularProgress
          size={24}
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            marginTop: "-12px",
            marginLeft: "-12px",
          }}
        />
      )}
      <Support
        isPopupOpen={isPopupOpen}
        onCancel={() => setIsPopupOpen(false)}
      ></Support>
      <Drawer
        anchor="top"
        open={tabsMenuopen}
        onClose={(e) => toggleDrawer(e, false)}
        PaperProps={{
          style: {
            width: "100%",
            height: isMobile ? "100%" : "auto",
          },
        }}
      >
        <Box
          className="tab-menu-bg"
          // display: 'flex',
          // flexDirection: 'column',
          // alignItems: 'center',
          // justifyContent: 'center',
          sx={{
            height: "100%",
          }}
        >
          <MenuItem className="d-flex justify-content-between py-3 px-2">
            <div className="fw-bold font-24">Menu</div>
            <div>
              <img
                src={closeOutline}
                alt="close"
                onClick={(e) => toggleDrawer(e, false)}
              ></img>
            </div>
          </MenuItem>
          {props.tabs &&
            props.tabs.length > 1 &&
            props.tabs.map((tab) => (
              <MenuItem
                key={tab.key}
                onClick={(e) => handleTabChange(e, tab)}
                disabled={Boolean(tab.disabled)}
                className={`px-3 py-2 ${
                  props.selectedTab === tab.key ? "selected-role" : ""
                }`}
              >
                {tab.name}
              </MenuItem>
            ))}
        </Box>
      </Drawer>
    </div>
  );
};

export default Header;
